<template>
  <div
    :class="`feature-card${selected ? '-selected py-5' : ' pt-5 pb-7'} ${selected && isTrialMode ? 'trial' : ''} fill-height`"
    :style="{ display: 'flex', flexDirection: 'column', position: 'relative', border: `${selected ? '5px solid ' + priceModel.highlightColor : '1px solid $fin-color-light-sky-blue'}`, marginTop: `${selected ? '0' : '4px'}`}">
    <v-icon
      v-if="groupPriceModel && (groupPriceModel.id === priceModel.id || isTrialAbo)"
      class="icon-check"
      style="color: white; background-color: #02073a; border-radius: 50%; position: absolute; right: -10px; top:-14px; font-size: 22px; padding: 3px;"/>

    <h1 v-style:color="priceModel.highlightColor" class="d-flex align-start flex-column">
      <span>{{ priceModel.name }}</span>
      <!-- style hidden to align the contents of the cards properly -->
      <span :style="`font-size:14px; ${isTrialAbo && profile ? '' : 'visibility: hidden;'}` " v-if="profile">
        (Kostenlose Testphase bis {{ profile.subscriptionChangeDate | date }})</span>
    </h1>

    <!-- flex 1 to align the contents in all cards properly on the same heights -->
    <div :class="`flex-sm-grow-1 mt-5 features-list-${groupPriceModel ? 'logged-in' : 'guest'}`">
      <fin-features-list :price-model="priceModel"/>
    </div>

    <div class="mt-5 d-block align-end" style="text-align: center;">
      <v-divider class="mb-5"/>

      <fin-price-switcher :price-model="priceModel"
                          :switcher-mode="false"
                          class="mb-3"/>

      <!-- only show buttons when user is logged in -->
      <div v-if="!isApp && !isTrialMode && protectedPage && groupPriceModel">
        <!-- BASIC users need to choose an abo -->
        <div v-if="groupPriceModel.id === 'BASIC'">
          <v-btn :style="priceModel.id === 'BASIC' ? 'visibility: hidden' : ''"
                 :disabled="isTrialMode"
                 dark
                 @click="selectPriceModel(priceModel)">
            Abo wählen
          </v-btn>
        </div>
        <!-- not-BASIC users can look at details or change their abo in stripe -->
        <div v-if="groupPriceModel.id !== 'BASIC'">
          <v-btn :style="groupPriceModel.id !== priceModel.id ? 'visibility: hidden' : ''"
                 class="mr-2 mb-2"
                 dark
                 @click="showPriceModel(priceModel)">
            Details
          </v-btn>
          <v-btn :style="groupPriceModel.id !== priceModel.id ? 'visibility: hidden' : ''"
                 :disabled="(priceModel.id !== 'BASIC' && priceModel.priceId === null) || isTrialMode"
                 class="mr-2 mb-2"
                 dark
                 @click="navigateToStripe(priceModel)">
            Abo anpassen
          </v-btn>
        </div>
      </div>
    </div>

    <p v-if="!isApp && protectedPage && priceModel.id !== 'BASIC' && priceModel.priceId === null"
       :style="{color: $finColors.paleRed}"
       class="pt-4">
      Momentan ist es wegen einem technischen Fehler nicht möglich, dieses Abo zu buchen. Versuch es bitte später
      erneut.
    </p>
  </div>
</template>

<script>

import FinFeaturesList from "@/components/pages/profile/subscription/AboFeaturesList"
import FinPriceSwitcher from "@/components/pages/profile/subscription/priceSwitcher"
import finBrowser from "@/js/finBrowser"
import {mapGetters} from "vuex"
import Stripe from "@/mixins/Stripe"

export default {
  name: "FinSubscriptionCard",
  components: {FinPriceSwitcher, FinFeaturesList},
  props: {
    priceModel: {
      type: Object,
    },
  },
  data() {
    return {
      viewModes: [],
      newPriceModel: null,
      protectedPage: this.$route.path.includes('/protected'),
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP,
      selected: false,
      isTrialAbo: false,
      isTrialMode: false
    }
  },
  mixins: [Stripe],
  computed: {
    ...mapGetters('auth', ['profile', 'groupPriceModel']),
  },
  methods: {
    selectPriceModel(priceDef) {
      const param = {priceModel: priceDef}
      this.$emit('selectNewSubscription', param)
    },
    navigateToStripe(priceDef) {
      this.navigateToStripeChangeAbo(undefined, priceDef, undefined)
    },
    showPriceModel(priceDef) {
      this.$emit('showSubscriptionDetails', priceDef)
    },
  },
  mounted() {
    this.isTrialAbo = this.groupPriceModel && this.groupPriceModel.id === 'TRIAL' && this.groupPriceModel.description.includes(this.priceModel.name)
    this.isTrialMode = this.groupPriceModel && this.groupPriceModel.id === 'TRIAL'

    if (this.groupPriceModel && (this.groupPriceModel.id === this.priceModel.id)) {
      this.selected = true
    } else if (this.isTrialAbo) {
      this.selected = true
    }
  }
}
</script>

<style lang="scss" scoped>

.feature-card, .feature-card-selected {
  box-shadow: $fin-color-card-shadow !important;
  -webkit-box-shadow: $fin-color-card-shadow !important;
  border-radius: 20px !important;
  padding: 40px 20px;

  h1 {
    font-family: $body-font-family;
    font-size: 26px;
    font-weight: 500;
  }

  ul {
    padding-left: 0;
  }

  li {
    list-style: none;
  }

  li > span {
    font-size: 18px;
  }

  .price {
    font-size: 24px;
    font-weight: bold;
  }

}

.feature-card {
  border: 1px solid $fin-color-light-sky-blue;
}

.trial {
  border-style: dashed !important;
}

.features-list-guest {
  ::v-deep .intro {
    display: none !important;
  }
}
</style>
